import QRCode from 'qrcode';

export class QRCodeGenerator {
  /**
   * Generate a QR code as a canvas element
   * @param {string} url - The URL to encode
   * @param {Object} options
   * @param {number} options.size - Size in pixels (default: 80)
   * @returns {Promise<HTMLCanvasElement>}
   */
  static async generate(url, { size = 80 } = {}) {
    const canvas = document.createElement('canvas');
    await QRCode.toCanvas(canvas, url, {
      width: size,
      margin: 1,
      color: {
        dark: '#ffffff',      // white QR code
        light: '#00000000',   // transparent background
      },
      errorCorrectionLevel: 'M',
    });
    return canvas;
  }

  /**
   * Create a styled QR code container element for embedding in the resume
   * @param {string} url
   * @returns {Promise<HTMLElement>}
   */
  static async createExportElement(url) {
    const container = document.createElement('div');
    container.className = 'export-qr-container';
    container.style.cssText = `
      position: absolute;
      bottom: 16px;
      right: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      z-index: 10;
    `;

    const label = document.createElement('span');
    label.textContent = 'SCAN TO VIEW';
    label.style.cssText = `
      font-family: 'Outfit', sans-serif;
      font-size: 8px;
      font-weight: 600;
      letter-spacing: 1px;
      color: rgba(255,255,255,0.6);
      text-transform: uppercase;
    `;

    const qrCanvas = await QRCodeGenerator.generate(url, { size: 80 });
    qrCanvas.style.cssText = `
      border-radius: 4px;
      background: rgba(0,0,0,0.5);
      padding: 4px;
    `;

    container.appendChild(label);
    container.appendChild(qrCanvas);
    return container;
  }
}
